module.exports = __webpack_public_path__ + "static/media/subaru-impreza-fig-1.69cdcb7b.jpg";